import { render, staticRenderFns } from "./document-upload.vue?vue&type=template&id=31e087b5&lang=pug&"
import script from "./document-upload.vue?vue&type=script&lang=js&"
export * from "./document-upload.vue?vue&type=script&lang=js&"
import style0 from "./document-upload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports